/**
 * Grow a textarea to fit its content, capped at `maxHeightPx` (uncapped when omitted).
 * Shared by the chat prompt box and the inline message editor.
 */
export default function resizeTextareaToContent(
    textarea: HTMLTextAreaElement | null | undefined,
    maxHeightPx?: number,
): void {
    if(!textarea) {
        return;
    }
    textarea.style.height = 'auto';
    const contentHeight = textarea.scrollHeight;
    const height = maxHeightPx ? Math.min(contentHeight, maxHeightPx) : contentHeight;
    textarea.style.height = `${height}px`;
    if(maxHeightPx) {
        textarea.style.overflowY = contentHeight > maxHeightPx ? 'auto' : 'hidden';
    }
}
